module.exports = __webpack_public_path__ + "img/icon_left_ask.308202a0.svg";